/**
 * Default starter snippets per script runtime.
 * Used when creating scripts and when switching runtime while the
 * editor still contains a known sample (or is empty).
 */

var DOC = "http://documentation.caseblocks.com/"

function block() {
  return Array.prototype.slice.call(arguments).join("\n") + "\n"
}

var SAMPLES = {
  expressive5: block(
    "// Caseblocks expressive5 (legacy sandbox) script",
    "// " + DOC,
    "//",
    "// In scope: payload, options, logger, cb, exit, fail",
    "//",
    "// payload  — flat case document (id, title, current_state, plus field uifs at top level).",
    "//            Not nested under properties. Mutate it, then exit(payload).",
    "// options  — run context (read-only):",
    "//              options.current_user  { id, email, display_name, account_code }",
    "//              options.params        task parameters from the task definition",
    "//              options.changed_fields  array of { name, from, to } on preSave / preStateChange",
    "//              options.authorization   execute JWT — already wired into cb; do not hard-code",
    "// logger   — logger.debug / info / warn / error  (appears in the script log)",
    "// cb       — authenticated GraphQL SDK (async, returns Promises)",
    "//",
    "// Terminate every code path:",
    "//   exit(payload)  success. pre* hooks persist this document; post* hooks do not (side effects only).",
    "//   fail(\"reason\")  controlled failure. preCreate / preSave abort the save.",
    "// Without exit/fail the run may hang. Async pattern:",
    "//   run(payload).then(function (doc) { exit(doc) }).catch(function (err) { fail(err.message) })",
    "//",
    "// Logging",
    "//   logger.info(\"starting\")",
    "//   logger.warn(\"unexpected state\")",
    "//   logger.error(\"could not look up related case\")",
    "//   Do not log tokens, passwords, or full authorization headers.",
    "//",
    "// cb SDK (await these — they return Promises)",
    "//   var row = await cb.getCase()",
    "//   var created = await cb.createCaseSimple(\"note\", { title: \"Follow up\" })",
    "//   await cb.updateCase({ properties: Object.assign({}, row.properties, { processed: true }) })",
    "//   await cb.createTimelineEvent(\"script ran\")",
    "//   var related = await cb.getRelated(\"project\", { page: 0, pageSize: 50 })",
    "//   var hits = await cb.search(\"claim\", \"status:open\", 1, 25, [\"title\"])",
    "//   await cb.executeCaseTask(\"c-1-2-3\")",
    "//   await cb.graphql(\"query { currentUser { email } }\", {})",
    "// getCase / updateCase / createCase use the GraphQL shape (properties bag, currentState).",
    "// Do not pass the flat payload straight to updateCase — map fields into properties.",
    "//",
    "// HTTP (callback style — still call exit/fail inside the callbacks)",
    "//   httpGetJson(url, {}, {}, function (body) { exit(payload) }, function (err) { fail(err) })",
    "//",
    "logger.info(\"starting\")",
    "exit(payload);"
  ),

  javascript: block(
    "// Caseblocks JavaScript script",
    "// " + DOC,
    "//",
    "// In scope: payload, options, document, logger, console, cb",
    "// This body is an async function — you can await at the top level.",
    "//",
    "// payload / document — flat case document (id, title, current_state, plus field uifs).",
    "//                      Not nested under properties. Return it (or a modified copy).",
    "// options            — run context (read-only):",
    "//                        options.current_user  { id, email, display_name, account_code }",
    "//                        options.params        task parameters from the task definition",
    "//                        options.changed_fields  array of { name, from, to } on preSave / preStateChange",
    "//                        options.authorization   execute JWT — already wired into cb; do not hard-code",
    "// logger             — logger.debug / info / warn / error  (appears in the script log)",
    "// console            — console.log / info / warn / error / debug  (same log, log → info)",
    "// cb                 — authenticated GraphQL SDK (async, returns Promises)",
    "//",
    "// Return:  return payload   (or a modified copy). pre* hooks persist it; post* hooks do not.",
    "// Fail:    throw new Error(\"reason\")  — becomes failureMessage; preCreate / preSave abort the save.",
    "//",
    "// Logging",
    "//   logger.info(\"starting\")",
    "//   logger.warn(\"skipping: missing title\")",
    "//   logger.error(\"lookup failed\")",
    "//   console.log(\"also works\", payload.id)",
    "//   Do not log tokens, passwords, or full authorization headers.",
    "//",
    "// cb SDK",
    "//   const row = await cb.getCase()",
    "//   const created = await cb.createCaseSimple(\"note\", { title: \"Follow up\" })",
    "//   await cb.updateCase({ properties: Object.assign({}, row.properties, { processed: true }) })",
    "//   await cb.createTimelineEvent(\"script ran\")",
    "//   const related = await cb.getRelated(\"project\", { page: 0, pageSize: 50 })",
    "//   const hits = await cb.search(\"claim\", \"status:open\", 1, 25, [\"title\"])",
    "//   await cb.executeCaseTask(\"c-1-2-3\")",
    "//   await cb.graphql(\"query { currentUser { email } }\", {})",
    "// getCase / updateCase / createCase use the GraphQL shape (properties bag, currentState).",
    "// Do not pass the flat payload straight to updateCase — map fields into properties.",
    "//",
    "logger.info(\"starting\")",
    "return payload"
  ),

  python: block(
    "# Caseblocks Python script",
    "# " + DOC,
    "#",
    "# In scope: payload, options, document, logger, result, json, cb",
    "#",
    "# payload / document — flat case document (id, title, current_state, plus field uifs).",
    "#                      Not nested under properties.",
    "# options            — run context (read-only):",
    "#                        options[\"current_user\"]  { id, email, display_name, account_code }",
    "#                        options[\"params\"]        task parameters from the task definition",
    "#                        options[\"changed_fields\"]  list of { name, from, to } on preSave / preStateChange",
    "#                        options[\"authorization\"]   execute JWT — already wired into cb; do not hard-code",
    "# logger             — logger.debug / info / warn / error  (appears in the script log)",
    "# result             — set this to the output document (defaults to payload)",
    "# cb                 — authenticated GraphQL SDK (sync). snake_case or camelCase aliases.",
    "#",
    "# Return:  result = payload   (or a modified copy). pre* hooks persist it; post* hooks do not.",
    "# Fail:    raise Exception(\"reason\")  — becomes failureMessage; preCreate / preSave abort the save.",
    "#",
    "# Logging",
    "#   logger.info(\"starting\")",
    "#   logger.warn(\"skipping: missing title\")",
    "#   logger.error(\"lookup failed\")",
    "#   Do not log tokens, passwords, or full authorization headers.",
    "#",
    "# cb SDK",
    "#   row = cb.get_case()",
    "#   created = cb.create_case_simple(\"note\", {\"title\": \"Follow up\"})",
    "#   cb.update_case({\"properties\": dict(row.get(\"properties\") or {}, processed=True)})",
    "#   cb.create_timeline_event(\"script ran\")",
    "#   related = cb.get_related(\"project\", {\"page\": 0, \"pageSize\": 50})",
    "#   hits = cb.search(\"claim\", \"status:open\", 1, 25, [\"title\"])",
    "#   cb.execute_case_task(\"c-1-2-3\")",
    "#   cb.graphql(\"query { currentUser { email } }\", {})",
    "# get_case / update_case / create_case use the GraphQL shape (properties bag, currentState).",
    "# Do not pass the flat payload straight to update_case — map fields into properties.",
    "#",
    "logger.info(\"starting\")",
    "result = payload"
  ),

  ruby: block(
    "# Caseblocks Ruby script",
    "# " + DOC,
    "#",
    "# In scope: payload, options, document, logger, cb",
    "#",
    "# payload / document — flat case document (id, title, current_state, plus field uifs).",
    "#                      Not nested under properties.",
    "# options            — run context (read-only):",
    "#                        options[\"current_user\"]  { id, email, display_name, account_code }",
    "#                        options[\"params\"]        task parameters from the task definition",
    "#                        options[\"changed_fields\"]  array of { name, from, to } on preSave / preStateChange",
    "#                        options[\"authorization\"]   execute JWT — already wired into cb; do not hard-code",
    "# logger             — logger.debug / info / warn / error  (appears in the script log)",
    "# cb                 — authenticated GraphQL SDK (sync). snake_case or camelCase aliases.",
    "#",
    "# Return:  the last expression is the output document. pre* hooks persist it; post* hooks do not.",
    "# Fail:    raise \"reason\"  — becomes failureMessage; preCreate / preSave abort the save.",
    "#",
    "# Logging",
    "#   logger.info(\"starting\")",
    "#   logger.warn(\"skipping: missing title\")",
    "#   logger.error(\"lookup failed\")",
    "#   Do not log tokens, passwords, or full authorization headers.",
    "#",
    "# cb SDK",
    "#   row = cb.get_case()",
    "#   created = cb.create_case_simple(\"note\", { \"title\" => \"Follow up\" })",
    "#   cb.update_case(\"properties\" => (row[\"properties\"] || {}).merge(\"processed\" => true))",
    "#   cb.create_timeline_event(\"script ran\")",
    "#   related = cb.get_related(\"project\", \"page\" => 0, \"pageSize\" => 50)",
    "#   hits = cb.search(\"claim\", \"status:open\", 1, 25, [\"title\"])",
    "#   cb.execute_case_task(\"c-1-2-3\")",
    "#   cb.graphql(\"query { currentUser { email } }\", {})",
    "# get_case / update_case / create_case use the GraphQL shape (properties bag, currentState).",
    "# Do not pass the flat payload straight to update_case — map fields into properties.",
    "#",
    "logger.info(\"starting\")",
    "payload"
  ),

  go: block(
    "// Caseblocks Go script — body of run(document, payload, options, logger, cb)",
    "// " + DOC,
    "//",
    "// In scope: document, payload, options any; logger cbLogger; cb *cbClient",
    "//",
    "// payload / document — flat case document (id, title, current_state, plus field uifs).",
    "//                      Not nested under properties. Typically map[string]any.",
    "// options            — run context (read-only map): current_user, params, changed_fields, authorization.",
    "//                      The execute JWT is already wired into cb; do not hard-code it.",
    "// logger             — logger.Debug / Info / Warn / Error  (appears in the script log)",
    "// cb                 — authenticated GraphQL SDK. Methods return (value, error).",
    "//",
    "// Return:  return a modified document to finish early, or fall through (wrapper returns document).",
    "//          pre* hooks persist it; post* hooks do not (side effects only).",
    "// Fail:    panic(\"reason\")  — becomes failureMessage; preCreate / preSave abort the save.",
    "//          Also panic(err) after a cb call that returned an error.",
    "//",
    "// Logging",
    "//   logger.Info(\"starting\")",
    "//   logger.Warn(\"skipping: missing title\")",
    "//   logger.Error(\"lookup failed\")",
    "//   Do not log tokens, passwords, or full authorization headers.",
    "//",
    "// cb SDK",
    "//   doc, _ := payload.(map[string]any)",
    "//   row, err := cb.GetCase()",
    "//   if err != nil { panic(err) }",
    "//   _, err = cb.CreateCaseSimple(\"note\", map[string]any{\"title\": \"Follow up\"})",
    "//   _, err = cb.CreateTimelineEvent(\"script ran\")",
    "//   related, err := cb.GetRelated(\"project\", map[string]any{\"page\": 0, \"pageSize\": 50})",
    "//   hits, err := cb.Search(\"claim\", \"status:open\", 1, 25, []string{\"title\"})",
    "//   _, err = cb.Graphql(\"query { currentUser { email } }\", map[string]any{})",
    "// GetCase / UpdateCase / CreateCase use the GraphQL shape (properties bag, currentState).",
    "// Do not pass the flat payload straight to UpdateCase — map fields into properties.",
    "//",
    "logger.Info(\"starting\")"
  ),

  rust: block(
    "// Caseblocks Rust script — body of run(document, payload, options, logger, cb) -> Value",
    "// " + DOC,
    "//",
    "// In scope: document, payload, options: Value; logger: Logger; cb: Cb",
    "// serde_json::{json, Value} is already imported.",
    "//",
    "// payload / document — flat case document (id, title, current_state, plus field uifs).",
    "//                      Not nested under properties. serde_json::Value object.",
    "// options            — run context (read-only): current_user, params, changed_fields, authorization.",
    "//                      The execute JWT is already wired into cb; do not hard-code it.",
    "// logger             — logger.debug / info / warn / error  (appears in the script log)",
    "// cb                 — authenticated GraphQL SDK. Methods return Result<Value, String>.",
    "//",
    "// Return:  return a modified Value, or fall through (wrapper returns document).",
    "//          pre* hooks persist it; post* hooks do not (side effects only).",
    "// Fail:    panic!(\"reason\")  — becomes failureMessage; preCreate / preSave abort the save.",
    "//          Use .expect(\"reason\") / unwrap_or_else(|_| panic!(...)) on cb Results.",
    "//",
    "// Logging",
    "//   logger.info(\"starting\");",
    "//   logger.warn(\"skipping: missing title\");",
    "//   logger.error(\"lookup failed\");",
    "//   Do not log tokens, passwords, or full authorization headers.",
    "//",
    "// cb SDK",
    "//   let row = cb.get_case(None).expect(\"get_case failed\");",
    "//   let _ = cb.create_case_simple(\"note\", json!({\"title\": \"Follow up\"}));",
    "//   let _ = cb.create_timeline_event(\"script ran\", None);",
    "//   let _ = cb.get_related(\"project\", Some(json!({\"page\": 0, \"pageSize\": 50})));",
    "//   let _ = cb.update_case(json!({\"properties\": {\"processed\": true}}));",
    "//   let _ = cb.graphql(\"query { currentUser { email } }\", json!({}));",
    "// get_case / update_case use the GraphQL shape (properties bag, currentState).",
    "// Do not pass the flat payload straight to update_case — map fields into properties.",
    "//",
    "logger.info(\"starting\");",
    "return document;"
  ),

  agentic: block(
    "Summarise the input document, note any obvious gaps, and write that onto agent_notes.",
    "",
    "# Caseblocks agentic script — this text is the TASK, not source code.",
    "# " + DOC,
    "#",
    "# The user message is the current case as JSON. When you finish, your entire final",
    "# message MUST be that same JSON object with your updates applied (no markdown,",
    "# no code fences, no prose-only reply). The platform saves it as the case document.",
    "#",
    "# Put findings on fields the TASK names. If you do not name a field, use agent_notes.",
    "# If you make no changes, return the input document unchanged.",
    "#",
    "# Use Caseblocks MCP tools (via the execute JWT) when you need to read or change data.",
    "# Optional account Runtime settings: llm_endpoint, llm_api_key, llm_model.",
    "# Optional Input overrides: llm_*, mcpServers, memory.enabled, max_steps.",
    "#",
    "# There is no logger/cb in this editor. Record problems on the document (e.g. agent_notes)",
    "# rather than throwing. The runtime logs the agent loop itself."
  ),

  custom: block(
    "// Caseblocks custom-image script",
    "// " + DOC,
    "//",
    "// This runtime POSTs to your image at /api/1/endpoint/execute.",
    "// Follow that image's runner contract. The platform request looks like:",
    "//   { name, sourceCode, inputDocument, options, sourceHash }",
    "// Respond with JSON:",
    "//   { outputDocument, log: [{ timestamp, level, message }] }     success",
    "//   { failureMessage, log: [...] }                               failure (blocks preCreate / preSave)",
    "//",
    "// Typical in-process names (if your image wraps snippets like the FaaS pools):",
    "//   payload / document — flat case JSON",
    "//   options            — current_user, params, changed_fields, authorization",
    "//   logger             — debug / info / warn / error  (appears in the script log)",
    "//   cb                 — GraphQL SDK authenticated with the execute JWT",
    "//",
    "// Logging: emit CBLOG lines on stderr as",
    "//   CBLOG {\"timestamp\": <ms>, \"level\": \"info\", \"message\": \"...\"}",
    "// or return them in the log array. Do not log tokens or passwords.",
    "//",
    "// Fail by returning failureMessage (or a non-zero process exit if your runner maps that).",
    "// " + DOC
  ),
}

/** Older / short forms still treated as “untouched sample”. */
var LEGACY_SAMPLES = [
  "//\n// Your code goes here\n//\n// http://documentation.caseblocks.com/\n//\nexit(payload);",
  "exit(payload);",
  "exit(payload)",
  "//\n// Your code goes here\n//\n// " + DOC + "\n//\n// Return the case document (or a modified copy).\nconsole.log(\"starting\", payload)\nreturn payload\n",
  "//\n// Your code goes here — body of Run(document)\n//\n// " + DOC + "\n//\n// Mutate document; the runtime returns it when the function ends.\n// Available: caseblocks.Find, FindAll, Create, Logger\nvar log caseblocks.Logger\nlog.Info(\"starting\")\n_ = document\n",
  "// Rust is not a platform FaaS pool yet (custom Docker image only).\n" +
    "// " + DOC + "\n" +
    "// Print JSON to stdout; that becomes the output document.\n" +
    "println!(\"{}\", document);\n",
  "println!(\"{}\", document);",
  "//\n" +
    "// Your code goes here — body of run(document, payload, options, logger, cb)\n" +
    "//\n" +
    "// " + DOC + "\n" +
    "//\n" +
    "// payload, options, document, and logger are in scope.\n" +
    "// The last expression is the output document.\n" +
    "logger.info(\"starting\");\n" +
    "document\n",
  "Summarise the input document and note any obvious gaps.\n" +
    "\n" +
    "# This editor text is the agent TASK.\n" +
    "# The image runs an OpenAI-compatible tool loop (not a remote agent service).\n" +
    "# Account defaults: Admin → Account → Runtime (endpoint, API key, model).\n" +
    "# Optional Input overrides: id, llm_*, mcpServers, memory.enabled, max_steps\n",
  "Summarise the input document and note any obvious gaps.\n" +
    "\n" +
    "# This editor text is the agent TASK (system prompt).\n" +
    "# cb-agent-runtime calls kagent POST /v1/chat/completions; kagent runs the MCP loop.\n" +
    "# Case JSON is the user message. MCP uses the execute JWT (and in-cluster http://mcp:3015/mcp).\n" +
    "# Optional account Runtime: llm_endpoint, llm_api_key (Vault), llm_model.\n",
  "//\n" +
    "// Your code goes here\n" +
    "//\n" +
    "// " + DOC + "\n" +
    "//\n" +
    "// Legacy expressive5: finish with exit(payload) or fail(message).\n" +
    "exit(payload);\n",
  "//\n" +
    "// Your code goes here\n" +
    "//\n" +
    "// " + DOC + "\n" +
    "//\n" +
    "// payload, options, document, logger, and cb are in scope.\n" +
    "// Return the case document (or a modified copy).\n" +
    "// await cb.createTimelineEvent(\"script ran\")\n" +
    "logger.info(\"starting\")\n" +
    "return payload\n",
  "#\n" +
    "# Your code goes here\n" +
    "#\n" +
    "# " + DOC + "\n" +
    "#\n" +
    "# payload, options, document, logger, and cb are in scope.\n" +
    "# Set `result = ...` to choose the output document.\n" +
    "# cb.create_timeline_event(\"script ran\")\n" +
    "logger.info(\"starting\")\n" +
    "result = payload\n",
  "#\n" +
    "# Your code goes here\n" +
    "#\n" +
    "# " + DOC + "\n" +
    "#\n" +
    "# payload, options, document, logger, and cb are in scope.\n" +
    "# The last expression is the output document.\n" +
    "# cb.create_timeline_event(\"script ran\")\n" +
    "logger.info(\"starting\")\n" +
    "payload\n",
  "//\n" +
    "// Your code goes here — body of run(document, payload, options, logger, cb)\n" +
    "//\n" +
    "// " + DOC + "\n" +
    "//\n" +
    "// Return the case document (or a modified copy).\n" +
    "// _, _ = cb.CreateTimelineEvent(\"script ran\")\n" +
    "logger.Info(\"starting\")\n" +
    "return document\n",
  "//\n" +
    "// Your code goes here — body of run(document, payload, options, logger, cb)\n" +
    "//\n" +
    "// " + DOC + "\n" +
    "//\n" +
    "// payload, options, document, logger, and cb are in scope.\n" +
    "// Return the case document (or a modified copy).\n" +
    "// let _ = cb.create_timeline_event(\"script ran\", None);\n" +
    "logger.info(\"starting\");\n" +
    "return document;\n",
  "Summarise the input document, note any obvious gaps, and write that onto agent_notes.\n" +
    "\n" +
    "# This text is the TASK. The runtime returns the case JSON (like return payload in JS).\n" +
    "# Put findings on the document. If you do not name a field, use agent_notes.\n" +
    "# MCP uses the execute JWT. Optional account Runtime: llm_endpoint, llm_api_key, llm_model.\n",
  "//\n" +
    "// Your code goes here\n" +
    "//\n" +
    "// Custom image — follow that image's runner contract.\n" +
    "// " + DOC + "\n" +
    "//\n",
];

function normalizeSample(code) {
  return String(code || "")
    .replace(/\r\n/g, "\n")
    .replace(/\s+$/g, "")
    .trim()
}

function allKnownSamples() {
  var list = LEGACY_SAMPLES.slice()
  Object.keys(SAMPLES).forEach(function (key) {
    list.push(SAMPLES[key])
  })
  return list
}

export function sampleForRuntime(preset) {
  var key = preset || "expressive5"
  if (key === "exp5") key = "expressive5"
  if (SAMPLES[key]) return SAMPLES[key]
  return SAMPLES.javascript
}

export function isKnownSample(code) {
  var normalized = normalizeSample(code)
  if (!normalized) return true
  return allKnownSamples().some(function (sample) {
    return normalizeSample(sample) === normalized
  })
}

export function applySampleIfSafe(currentCode, preset) {
  if (!isKnownSample(currentCode)) return currentCode
  return sampleForRuntime(preset)
}

export default {
  sampleForRuntime,
  isKnownSample,
  applySampleIfSafe,
  SAMPLES,
}
